import React, { useState, useEffect } from "react";
import { Button } from "@onegovbugs/onegov-react-components";
import styles from "./proofOfIdentity.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { saveApplication } from "../../redux/actions";
import { RedirectIfCaptchaNotSelected, RedirectIfPrerequisitesNotSelected } from "../../utils/redirect";
import ScrollToTop from "../../utils/scrollToTop";

const ProofOfIdentity = props => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfPrerequisitesNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12"}>
          <p>
            The applicant must provide to SLED copies of two forms of personal identification of an approved kind.
          </p>
          <p>
            Approved forms of personal identification are listed in the Fact Sheet {""}
            <a target="_blank" href="https://www.police.nsw.gov.au/online_services/sled/tattoo_industry_licences">
               Applying for a Tattooist Licence
            </a>.
          </p>             
          <p>All required certified documents must be forwarded, by post, to:</p>
          <ul>
            <li>SLED</li>
            <li>Locked Bag 5099</li>
            <li>PARRAMATTA  NSW  2124</li>
          </ul>
        </div>
      </div>
      <div className={`row ` + styles.topMargin128}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              props.history.push(`./upload-documents`);
            }}
          >
            Continue
          </Button>
          <Button
            secondary
            onClick={() => {
              dispatch(
                saveApplication("step5", () => {
                  window.location.href = `${process.env.REACT_APP_BAU_URL}`;
                })
              );
            }}
          >
            Save & exit section
        </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(props => <ProofOfIdentity {...props} />);
